module.exports = __webpack_public_path__ + "img/send_on.d06864ab.svg";